import { StateWarning } from "@/services/backend/processes/components/state/state-warning";
import {
  ProcessPageMain,
  ProcessPageMainContent,
  ProcessPageMainHeader,
  ProcessSidebarTrigger,
} from "@/shared/bsm/core/process/components/ui/process-page";
import { Separator } from "@/shared/components/ui/separator";
import { ReactNode } from "react";
import { useParams } from "react-router";

export function ProcessPageMainTemplate({
  breadcrumbs,
  children,
}: {
  breadcrumbs: ReactNode;
  children: ReactNode;
}) {
  const { processId } = useParams();
  return (
    <ProcessPageMain className="pt-16">
      <ProcessPageMainHeader>
        <ProcessSidebarTrigger />
        <Separator
          orientation="vertical"
          className="mr-2 data-[orientation=vertical]:h-4"
        />
        {breadcrumbs}
      </ProcessPageMainHeader>
      <ProcessPageMainContent>
        <StateWarning processId={processId!} />
        {children}
      </ProcessPageMainContent>
    </ProcessPageMain>
  );
}
